module.exports = __webpack_public_path__ + "static/media/skype-logo.d45d32fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/how-it-works-requirements/skype-logo.svg
// module id = 232
// module chunks = 0